import { ELSStepperItem } from '@els/els-component-shared-ts-react';

export const EXTERNAL_LINK_ASSIGNMENT_EDITOR_PAGE_TITLE = 'External Link Assignment';

export const MAX_URL_STRING_LENGTH = 10000;

export const URL_REG_EX = '^(http:\\/\\/www\\.|https:\\/\\/www\\.|http:\\/\\/|https:\\/\\/)[a-z0-9]+([\\-\\.]{1}[a-z0-9]+)*\\.[a-z]{2,5}(:[0-9]{1,5})?(\\/.*)?$';

export enum ExternalLinkStep {
  STEP1 = 'STEP1',
}

export const ExternalLinkDefaultSteps: ELSStepperItem[] = [
  {
    heading: 'Assignment',
    id: ExternalLinkStep.STEP1,
    isActive: false,
    isClickable: false,
    isComplete: false,
    isReady: false,
    showActionButtons: true,
    subtitle: 'Assignment',
    title: 'Step 1',
  }
];
